export const locale = {
    lang: 'zh2',
    data: {
      'EDITOR': {
        'ACERCADE': '（可选）在创建调查之前，您可以编辑调查的某些特征，访问调查后可以在调查中查看所做的更改',
        'CONCAMBIOS': '检测到对测量配置的更改，您必须首先生成要应用的更改的测量，之后才能完成该步骤',
        'CARGANDO': '加载信息',
        'GUARDANDO': '保存更改',
        'CONFIGADICIONAL': {
          'TITULO': '附加配置',
          'SUBTITULO': '这些设置适用于所有语言的调查',
          'DISPONIBLES': '可用的控件',
          'SAVEOK': '配置已成功更新',
          'CONTROLES': {
            'PIN': '使用用户PIN启用调查保护',
            'RANDOM': '启用随机验证问题',
            'LIDERES': '在陈述的观点中显示领导者的名字（CEO / Boss）'
          }
        },
        'ELEMENTOS': {
          'GUIA': '该块的元素',
          'COLORES': {
            'ORIGINAL': '未修改的元素',
            'MODIFICADO': '修改元素'
          },
          'TOOLTIPS': {
            'ORIGINAL': '尚未修改任何元素',
            'MODIFICADO': '一个或多个元素已被修改',
            'COMPLETO': '所有元素均已修改'
          },
          'ETIQUETAS': {
            'IMAGEN': {
              'NOHAY': '没有图片',
              'ACTUAL': '当前图像'
            },
            'TEXTO': {
              'INGRESAR': '输入你的文字'
            }
          },
          'BOTONES': {
            'ENTRAR': '编辑调查特征',
            'REGRESAR': '回去',
            'CONTINUAR': '继续',
            'CANCELAR': '取消',
            'GUARDAR': '保存更改',
            'IMAGEN': '变更图片',
            'EDITOR': '编辑讯息',
            'ELEMENTOS': '帮助',
            'ACTIVAR': '展示',
            'DESACTIVAR': '隐藏',
            'ACEPTAR': '接受',
          }
        },
        'PANTALLAS': {
          'LOGIN': {
            'TITULO': '登录',
            'PASOS': {
              'LOGO': {
                'TITULO': '经纪人徽标',
                'ELEMENTOS': {
                  'logo': '您可以上传图片来更改经纪人的徽标'
                }
              },
              'INSTRUCCIONES': {
                'TITULO': '先前的指示',
                'ELEMENTOS': {
                  'text': '您可以编写说明以进入调查之前显示'
                }
              },
              'LOGINFORM': {
                'TITULO': '登录表格',
                'ELEMENTOS': {
                  'inputPlaceHolderPass': '您可以更改“密码”字段的提示文本',
                  'buttons_login_label': '您可以更改登录按钮的文本',
                  'recoveryAccessKey_text': '您可以更改按钮文字以恢复密码',
                }
              },
              'BACKGROUND': {
                'TITULO': '背景图像',
                'ELEMENTOS': {
                  'backgroudImage': '您可以更改此屏幕上显示的背景图像',
                }
              },
            }
          },
          'GENERICOS': {
            'TITULO': '通用元素',
            'PASOS': {
              'LOGO': {
                'TITULO': '经纪人徽标',
                'ELEMENTOS': {
                  'logo': '您可以上传图片来更改经纪人的徽标'
                }
              },
              'HEADER': {
                'TITULO': '标头元素',
                'ELEMENTOS': {
                  'buttons_logout_label': '您可以更改登录按钮的文本',
                  'header_logo': '您可以更改系统徽标的图像',
                  'isShowLastLogin_active': '您可以选择显示或隐藏上次访问的日期',
                  'backgroundImage': '您可以更改此屏幕上显示的背景图像',
                  'header_showUserName': '您可以选择显示或隐藏用户名'
                }
              },
            }
          },
          'BIENVENIDA': {
            'TITULO': '欢迎画面',
            'PASOS': {
              'CONTENIDO': {
                'TITULO': '屏幕内容',
                'ELEMENTOS': {
                  'text': '您可以修改欢迎屏幕的内容',
                  'buttons_next_label': '您可以更改按钮文字以继续',
                }
              },
              'LOGOUT': {
                'TITULO': '登出时的讯息',
                'ELEMENTOS': {
                  'title': '您可以更改消息标题',
                  'text': '您可以更改消息的文本',
                  'buttons_cancel_label': '您可以更改按钮文字以取消操作',
                  'buttons_logout_label': '您可以更改按钮的文本以注销',
                }
              },
            }
          },
          'INSTRUCCIONES': {
            'TITULO': '指令画面',
            'PASOS': {
              'CONTENIDO': {
                'TITULO': '屏幕内容',
                'ELEMENTOS': {
                  'text': '您可以修改说明屏幕的内容',
                  'buttons_previous_label': '您可以更改按钮文字以返回',
                  'buttons_start_label': '您可以更改按钮文字以开始',
                  'buttons_continue_label': '您可以更改按钮文字以继续',
                }
              },
              'LOGOUT': {
                'TITULO': '登出时的讯息',
                'ELEMENTOS': {
                  'title': '您可以更改消息标题',
                  'text': '您可以更改消息的文本',
                  'buttons_cancel_label': '您可以更改按钮文字以取消操作',
                  'buttons_logout_label': '您可以更改按钮的文本以注销',
                }
              },
            }
          },
          'TERMINOS': {
            'TITULO': '调查验收信息',
            'PASOS': {
              'ACTIVAR': {
                'TITULO': '激活消息以接受或拒绝调查',
                'ELEMENTOS': {
                  'active': '激活启动前消息'
                }
              },
              'CONTENIDO': {
                'TITULO': '留言内容',
                'ELEMENTOS': {
                  'header_title': '您可以更改消息标题',
                  'text': '您可以更改消息的内容',
                  'buttons_previous_label': '您可以更改按钮文字以返回',
                  'buttons_acept_label': '您可以更改按钮文字以拒绝调查',
                  'buttons_cancel_label': '您可以更改按钮文字以接受调查'
                }
              },
              'LOGOUT': {
                'TITULO': '登出时的讯息',
                'ELEMENTOS': {
                  'title': '您可以更改消息标题',
                  'text': '您可以更改消息的文本',
                  'buttons_cancel_label': '您可以更改按钮文字以取消操作',
                  'buttons_logout_label': '您可以更改按钮的文本以注销',
                }
              },
              'NOACEPT': {
                'TITULO': '拒绝调查时的提示',
                'ELEMENTOS': {
                  'title': '您可以更改消息标题',
                  'text': '您可以更改消息的文本',
                  'buttons_saveAndExit_label': '您可以更改按钮文本以确认并退出',
                }
              },
            }
          },
          'SURVEY': {
            'TITULO': '调查画面',
            'PASOS': {
              'NAV': {
                'TITULO': '导航按钮',
                'ELEMENTOS': {
                  'buttons_next_label': '您可以更改按钮文字以继续',
                  'buttons_previous_label': '您可以更改按钮文字以返回',
                  'buttons_finish_label': '您可以更改按钮文字以结束调查',
                }
              },
              'INSTRUCCIONES': {
                'TITULO': '指令侧面板',
                'ELEMENTOS': {
                  'button_label': '您可以更改按钮文本以显示说明面板',
                  'active': '您可以选择显示或隐藏说明面板上的按钮',
                  'text': '您可以修改说明屏幕的内容',
                }
              },
              'SOPORTE': {
                'TITULO': '支撑提示侧面板',
                'ELEMENTOS': {
                  'button_label': '您可以更改按钮文本以显示支持提示面板',
                  'active': '您可以选择显示或隐藏支持提示面板按钮',
                  'text': '您可以修改支持提示屏幕的内容',
                }
              },
              'COLUMNA1': {
                'TITULO': '陈述：观点1',
                'ELEMENTOS': {
                  'title': '您可以更改透视图1的列标题',
                  'tooltip_active': '您可以选择显示或隐藏列标题工具提示',
                  'tooltip_text': '您可以修改列标题工具提示的内容',
                }
              },
              'COLUMNA2': {
                'TITULO': '陈述：观点2',
                'ELEMENTOS': {
                  'title': '您可以更改透视图2的列标题',
                  'tooltip_active': '您可以选择显示或隐藏列标题工具提示',
                  'tooltip_text': '您可以修改列标题工具提示的内容',
                }
              },
              'FINISH_1': {
                'TITULO': '调查结束时的消息',
                'ELEMENTOS': {
                  'title': '您可以更改消息标题',
                  'textAnswered': '您可以在回答所有问题时修改显示的消息文本',
                  'textNotAnswered': '您可以通过不回答所有问题来修改显示消息的文本',
                  'textFooter': '您可以修改消息文本',
                  'buttons_previous_label': '您可以更改按钮文字以返回',
                  'buttons_close_label': '您可以更改按钮文字以结束调查',
                }
              },
              'FINISH_2': {
                'TITULO': '完成调查后的消息',
                'ELEMENTOS': {
                  'windowFinishMessage_title': '您可以更改消息标题',
                  'windowFinishMessage_text': '您可以修改消息文本',
                  'windowRanking_active': '您可以选择显示或隐藏消息以对调查进行评分',
                  'windowRanking_text': '您可以修改消息文本以对调查进行评分',
                  'windowFinishMessage_buttons_close_label': '您可以更改按钮文字以继续',
                }
              },
              'LOGOUT_1': {
                'TITULO': '登出时的讯息',
                'ELEMENTOS': {
                  'title': '您可以更改消息标题',
                  'text': '您可以修改消息文本',
                  'textBandRequired': '您可以修改不可逆警告消息的文本',
                  'buttons_previous_label': '您可以更改按钮文字以取消操作',
                  'buttons_saveAndExit_label': '您可以更改按钮文本以保存更改并注销',
                }
              },
              'LOGOUT_2': {
                'TITULO': '登出后的讯息',
                'ELEMENTOS': {
                  'title': '您可以更改消息标题',
                  'text': '您可以修改消息文本',
                  'buttons_close_label': '您可以更改按钮文字以继续',
                }
              },
            }
          },
        }
      }
    }
};
